(() => {
  const elements = document.querySelectorAll('[js-dynamic-country]');
  if (!elements.length) return;

  const formatCountryKey = (code) => {
    return code.trim().toLowerCase();
  };

  const getGeo = async () => {
    let geo = window.wigiwama?.geolocation;

    if (!geo) {
      try {
        geo = await window.wigiwama.functions.queryLocale();
      } catch (e) {
        console.warn('Locale detection failed', e);
        return null;
      }
    }

    return geo;
  };

  const calculateDeliveryDate = (daysStr) => {
    const parts = daysStr.split('-');
    const minDays = parseInt(parts[0], 10);
    const maxDays = parseInt(parts[parts.length - 1], 10);
    const avgDays = Math.round((minDays + maxDays) / 2);

    if (isNaN(avgDays)) return null;

    const date = new Date();
    let daysAdded = 0;
    while (daysAdded < avgDays) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) {
        daysAdded++;
      }
    }

    const dayNames   = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                        'July', 'August', 'September', 'October', 'November', 'December'];

    return `${dayNames[date.getDay()]}, ${monthNames[date.getMonth()]} ${date.getDate()}`;
  };

  const updateElement = async (el) => {
    el.setAttribute('state', 'loading');

    const geo = await getGeo();
    const countryCode = geo?.countryCode;
    const countryName = geo?.countryName;

    const key = countryCode ? formatCountryKey(countryCode) : null;
    const days = key && el.getAttribute(`data-country-${key}`);

    if (!days) {
      const fallbackHTML = el.querySelector('.delivery-fallback')?.innerHTML || '';
      el.innerHTML = fallbackHTML;
      el.setAttribute('state', 'ready');
      return;
    }

    const deliveryDate = calculateDeliveryDate(days);

    const templateHTML = el.querySelector('.delivery-template')?.innerHTML || '';
    const resultHTML = templateHTML
      .replaceAll('[[ country ]]', countryName)
      .replaceAll('[[ days ]]', `<strong>${days}</strong>`)
      .replaceAll('[[ date ]]', deliveryDate ? `<strong>${deliveryDate}</strong>` : `<strong>${days} working days</strong>`);

    el.innerHTML = resultHTML;
    el.setAttribute('state', 'ready');
  };

  elements.forEach(updateElement);
})();